module.exports = __webpack_public_path__ + "img/ferris_wheel.cb458ff8.gif";